import { MARKETO_BASE_URL } from 'utils/marketo/config';

let scriptPromise: Promise<void> | null = null;

const loadMarketoScript = (): Promise<void> => {
  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (window.MktoForms2) {
    return Promise.resolve();
  }

  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = new Promise<void>((resolve, reject) => {
    const existing = document.getElementById('mktoForms2') as HTMLScriptElement | null;

    if (existing) {
      if (window.MktoForms2) {
        resolve();
      } else {
        existing.addEventListener('load', () => resolve());
        existing.addEventListener('error', reject);
      }

      return;
    }

    const script = document.createElement('script');
    script.id = 'mktoForms2';
    script.src = `${MARKETO_BASE_URL}/js/forms2/js/forms2.min.js`;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = reject;

    document.body.appendChild(script);
  });

  return scriptPromise;
};

export default loadMarketoScript;
